import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=61a986e9&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=61a986e9&lang=scss"
import style1 from "./Landing.vue?vue&type=style&index=1&id=61a986e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a986e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a986e9')) {
      api.createRecord('61a986e9', component.options)
    } else {
      api.reload('61a986e9', component.options)
    }
    module.hot.accept("./Landing.vue?vue&type=template&id=61a986e9&scoped=true", function () {
      api.rerender('61a986e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/landing/Landing.vue"
export default component.exports